import Api from './api'
import Storage from '../helpers/storage'
import UserAgent from '../modules/userAgent'
import Store from '../store'
import Notifs from '../modules/notifications'

export default {

    connect: function (email, password, device, language, {oAuthCode, oAuthCodeVerifier}) {

        const params = {
            email: email,
            code: password,
            device: device,
            language: language.split('-')[0],
            signUpReferrer: Storage.getItem('referrer'),
            signUpUtmSource: Storage.getItem('utm_source'),
            signUpUtmCampaign: Storage.getItem('utm_campaign'),
            signUpUtmMedium: Storage.getItem('utm_medium')
        }
        if (oAuthCodeVerifier) {
            params.oAuthCode = oAuthCode
            params.oAuthCodeVerifier = oAuthCodeVerifier
        }

        return Api.put('/auth', params)

    },

    disconnect() {

        const appInstanceId = Notifs.getUniqueKey()
        return Api.post('/v3/users/logout', { appInstanceId })
            .catch(()=>{})

    },

    authCheck: function () {

        const aToken = Storage.getItem('aToken')
        return Api.get('/auth/check', { 'x-async-token': aToken })

    },

    deleteEmailAccount: function (email) {

        return Api.delete(`/v3/accounts/${ email }`)

    },

    deleteEmailAccountCheck: function (email) {

        const aToken = Storage.getItem('aToken')

        return Api.get(`/v3/accounts/${ email }/check`, { 'x-async-token': aToken })

    },

    sendMagicLinkEmail: function (email, language) {

        return Api.put('/auth/magic', { email, language: language.split('-')[0] })

    },

    getMagicLinkUser: function (code) {

        return Api.get('/auth/magic/check', { 'x-magic-token': code })

    },

    authLongCheck: function (code) {

        return Api.get('/auth/long/check', { 'X-Long-Auth-Token': code })

    },

    validConsent: function (body, utms) {

        if(utms.utm_source) { body.signUpUtmSource = utms.utm_source }

        if(utms.utm_campaign) { body.signUpUtmCampaign = utms.utm_campaign }

        if(utms.utm_medium) { body.signUpUtmMedium = utms.utm_medium }

        if(utms.referrer) { body.signUpReferrer = utms.referrer }

        return Api.put('/auth/consent', body)

    },

    futureContact: function (email) {
        const body = {
            email,
            language: Store.getters.lang,
            device: UserAgent.getDevice()
        }

        return Api.put('/auth/consent/future-contact', body)
            .catch(()=>{})
    }

}
